<!--
@component
CardsDefault

See markup below.
-->

<script lang="ts">
  import { fly } from 'svelte/transition';
  import { appState } from '$lib/stores/index.svelte';
  import type { CommentaryEntry } from '$lib/@types';

  let {
    comment,
    i,
    isLive = false,
  }: { comment: CommentaryEntry; i: number; isLive?: boolean } = $props();

  // Cap stagger so very long lists don't end up with multi-second delays.
  const MAX_DELAY = 1000;
  const STEP = 50;

  const isMobile = $derived(appState.windowWidth <= 660);
  const flyDelay = $derived(Math.min(i * STEP, MAX_DELAY));
</script>

<div
  class="comment-container"
  in:fly|global={{ y: -35, duration: 500, delay: flyDelay }}
>
  {#if !isMobile}
    <div class="minute">{comment.time}</div>
  {/if}

  <div class="commentary" class:latest={i === 0 && isLive}>
    <div class="content">
      <div class="comment">
        {#if isMobile}
          <div class="minute">{comment.time}</div>
        {/if}
        <p>{comment.comment}</p>
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  @use 'layout' as *;

  .commentary {
    padding: ($padding * 0.5) $padding;

    @media (max-width: 660px) {
      padding: 0.75rem 2rem 1.5rem;
    }

    .comment p {
      font-size: calc(0.8 * var(--theme-font-size-base));
      line-height: 1.25;
    }
  }
</style>
